    <div class="modal fade" id="ModalTable" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered" style="display: flex;justify-content: center;align-items: center;">
    <div class="modal-content" >
      <div class="modal-header">
      <div class="modal-title-wrapper">
          <h1 class="modal-title-main">{{modaltitle2}}</h1>
          <span class="modal-subtitle" [ngStyle]="!modaltitle2 ? {'font-weight':'600','font-size':'16px !important'} : {}" >{{Modaltitle}}</span>
      </div>
      <button type="button" class="btn-close" (click)="closemodal()"></button>
      </div>
      <div class="modal-body">
        <div class="card">
          

          <div class="card-body" id="site_tabular" style="padding-top: 14px;">
            <div class="header" style="display: flex;justify-content: space-between;align-items: center;">
              <div class="d-flex justify-content-start align-items-center " style="font-weight: 600;font-size: 18px;">{{TableHeader}}</div>
              <div class="header-actions-wrapper">
                <div class="header-actions">
                
                <!-- Show as tags if screen is more than 600px -->
                <ng-container *ngIf="!isMobileView && ExportFileName === 'Site Data'">
                  <ng-container *ngFor="let filter of filterConfig">
                    <div
                      class="filter-active"
                      *ngIf="statusMap[filter.key] === 'active'"
                      [ngStyle]="{ 'animation-delay': (filter.key.length * 50) + 'ms' }"
                      (click)="updateStatus(filter.key)">
                      <span>{{ filter.label }}</span>
                      <img class="ximage" src="assets/DashboardIcon/x-primary.svg" alt="">
                    </div>
                  </ng-container>
                </ng-container>
                
                <!-- Show dropdown if screen is 600px or less -->
                <ng-container *ngIf="isMobileView && !isSearchOpen && ExportFileName === 'Site Data'">
                  <div class="filter-dropdown-container">
                    <div 
                      class="filter-dropdown-toggle" 
                      (click)="toggleDropdown()"
                      [class.active]="isOpen">
                      <span class="filter-count">{{ activeFiltersCount }}</span>
                    </div>
                    
                    <div class="filter-dropdown-content" [class.show]="isOpen">
                      <div class="filter-items">
                        <ng-container *ngFor="let filter of filterConfig">
                          <div
                            class="filter-active-item"
                            *ngIf="statusMap[filter.key] === 'active'"
                            [ngStyle]="{ 'animation-delay': (filter.key.length * 50) + 'ms' }"
                            (click)="updateStatus(filter.key)">
                            <span>{{ filter.label }}</span>
                            <img class="ximage" src="assets/DashboardIcon/x-primary.svg" alt="remove filter">
                          </div>
                        </ng-container>
                
                        <div class="no-filters" *ngIf="activeFiltersCount === 0">
                          <span>
                            No active filters
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <div *ngIf="ShowDLFilter === true"> 
                  <!-- Not showing this Incase Coming from service provider with command for DLList data and See Service Poriders and Status -->
                  @for(outlineitem of CustomOutlineData; track outlineitem){
                    <div class="btn-group btn-group-pill">
                      @for(buttonsitem of outlineitem.item; track buttonsitem) {
                        <button
                          style="padding: 0.2rem 0.75rem !important;"
                          class="btn {{buttonsitem.class}}"
                          [ngClass]="{'active': selectedKey === buttonsitem.key}"
                          type="button"
                          (click)="SelectDataloggerData(buttonsitem.key)">
                          {{buttonsitem.text}}
                        </button>
                      }
                    </div>
                  }
                </div>
                <div *ngIf="!pageNation" class="search-container" ngbTooltip = 'Search' placement = 'top'>
                  <input type="text"       
                  class="search-bar form-control" 
                  [class.open]="isSearchOpen"
                  id="filter-text-box" placeholder="Filter..." #filterTextBox  (input)="onFilterTextBoxChanged()" />    
                          <button class="tablebtns" (click)="toggleSearch()">
                    <img height="24" width="24" src="assets/images/Icons/Search.png" alt="Search">
                  </button>
                </div>  
                <div class="columnsearchfilter" ngbTooltip = 'Column Search Filter' placement = 'top' *ngIf="!pageNation">
                  <button  class="tablebtns"  (click)="toggleFloatingFilter()" >
                <img height="24" width="24" [src]="filterIcon" alt="Filter records">
              
                  </button>
                </div>
                <div class="ColumnFilters" ngbTooltip = 'Column Filter' placement = 'top'>
                  <button   class="tablebtns" (click)="toggleColumnMenu($event)">
                    <img height="24" width="24" src="assets/images/Icons/SideColumns.png"  alt="SideColumns">
                  </button>
          
                </div>
          
                <div ngbTooltip = 'Download CSV' placement = 'top'>
                  <button  class="tablebtns" (click)="onExport()">
                    <img height="24" width="24" src="assets/images/Icons/Download.png" alt="Download">
                      </button>
                </div>
                <div *ngIf="displayAddbutton" class="siteaddBtn btn" [routerLink]="'/addsites'">Add Site</div>

                <div *ngIf="addApplication == true"  placement = 'top'>
                  <button  class="add-application" data-bs-toggle="modal"[attr.data-bs-target]="'#' + modalId"
                  >
                        +Add {{buttonTitle}}
                  </button>
                </div>
                <div *ngIf="AddBulkaction == true"  placement = 'top'>
                  <button  class="add-application" (click)="CreateBulkAction()">
                        + Create New Bulk
                  </button>
                </div>
                <div class="date-range-wrapper" *ngIf="DateFilterShow && !isMobileView">
                    <input
                      class="form-control datepicker"
                      type="text"
                      placeholder="From  -  To"
                      mwlFlatpickr
                      [disableMobile]="true"
                      [altInput]="true"
                      [altFormat]="'d/m/Y'"
                      [dateFormat]="'Y-m-d'"
                      [mode]="'range'"
                      [(ngModel)]="dateRange"
                      (ngModelChange)="updateFormattedDates()"/>
                    <img src="assets/DashboardIcon/calendar-icon.svg" class="calendar-icon" alt="Calendar Icon" />
                </div>
              </div>
              </div>

            </div>
            <div class="date-range-wrapper mobile-view" *ngIf="DateFilterShow && isMobileView">
                <input
                  class="form-control datepicker"
                  type="text"
                  placeholder="From  -  To"
                  mwlFlatpickr
                  [disableMobile]="true"
                  [altInput]="true"
                  [altFormat]="'d/m/Y'"
                  [dateFormat]="'Y-m-d'"
                  [mode]="'range'"
                  [(ngModel)]="dateRange"
                  (ngModelChange)="updateFormattedDates()"/>
                <img src="assets/DashboardIcon/calendar-icon.svg" class="calendar-icon" alt="Calendar Icon" />
            </div>

            <div *ngIf="showColumnMenu" class="column-menu-wrapper" >
              <div class="column-visibility-menu card">
                <div class="menu-header">
                  <button class="" (click)="hideAll()" [disabled]="isHideAllDisabled" ><p>Hide all</p></button>
                  <button (click)="showAll()" [disabled]="isShowAllDisabled"><p>Show all</p></button>
                </div>
                <div class="menu-body">
                  
                  <p class="menu-item" *ngFor="let colDef of columnDefs">
                    <label class="switch">
                      <input type="checkbox" [checked]="!colDef.hide" (change)="toggleColumnVisibility(colDef)">
                      <span class="slider round"></span>
                    </label>
                    <span>
                      {{ colDef.headerName }}          
                    </span>
                  </p>
                </div>
              </div>
            </div>  
                <ag-grid-angular
                  style="width: 100%; height: 500px;"
                  class="ag-theme-quartz"
                  [suppressColumnVirtualisation]="true"
                  [rowData]="rowData"
                  [columnDefs]="columnDefs"
                  [defaultColDef]="defaultColDef"
                  [autoSizeStrategy]="autoSizeStrategy"
                  [pagination]="true"
                  [paginationPageSizeSelector]="paginationPageSizeSelector"
                  enableCellTextSelection="true"
                  [enableCellSpan]="true"
                  [paginationPageSize]="10"
                  (gridReady)="onGridReady($event)"
                  (paginationChanged)="onPaginationChanged($event)"
                  theme="legacy"
                  [pinnedBottomRowData]="pinnedBottomRowDataModal" 
                >
                </ag-grid-angular>

        </div>
        </div>
      </div>
    </div>


      </div>
    </div>
